
import { toast } from "react-toastify";
import SuccessCard from "../components/toast/success";
import WarningCard from "../components/toast/warning";
import InfoCard from "../components/toast/info";
import ErrorCard from "../components/toast/error";

const baseToastConfig = {
  className: "!bg-transparent !shadow-none !p-0",
  bodyClassName: "!p-0",
  closeButton: false,
  hideProgressBar: true,
};

export const showSuccessToast = (message) =>
  toast(
    ({ closeToast }) => (
      <SuccessCard
        title="Success"
        message={message}
        subText="Everything seems great"
        closeToast={closeToast}
      />
    ),
    baseToastConfig
  );

export const showWarningToast = (message) =>
  toast(
    ({ closeToast }) => (
      <WarningCard
        title="Warning"
        message={message}
        subText="Please check this carefully"
        closeToast={closeToast}
      />
    ),
    baseToastConfig
  );


  export const showErrorToast = (message) =>
  toast(
    ({ closeToast }) => (
      <ErrorCard
        title="Error"
        message={message}
        subText="Something went wrong"
        closeToast={closeToast}
      />
    ),
    baseToastConfig
  );


  export const showInfoToast = (message) =>
  toast(
    ({ closeToast }) => (
      <InfoCard
        title="Info"
        message={message}
        subText="For your information"
        closeToast={closeToast}
      />
    ),
    baseToastConfig
  );